import {Action} from '@ngrx/store';
import {
  DeletePendingOrganizationMemberRequest,
  DeletePendingOrganizationUserRequest,
  GetOrganizationUsersRequest,
  GetSelfOrganizationUserRequest,
  OrganizationUser,
  PostGroupInvitationRequest,
  PostOrganizationInvitationRequest,
  SelfOrganizationUser
} from '../models/organization-user';
import {ErrorPayload} from '../models/general';

export enum OrganizationUserActionTypes {
  GetOrganizationUsers = '[OrganizationUser] Get Organization Users',
  GetOrganizationUsersComplete = '[OrganizationUser] Get Organization Users Complete',
  GetOrganizationUsersError = '[OrganizationUser] Get Organization Users Error',
  GetSelfOrganizationUser = '[OrganizationUser] Get Self Organization User',
  GetSelfOrganizationUserComplete = '[OrganizationUser] Get Self Organization User Complete',
  GetSelfOrganizationUserError = '[OrganizationUser] Get Self Organization User Error',
  PostOrganizationInvitation = '[OrganizationUser] Post Organization Invitation',
  PostOrganizationInvitationComplete = '[OrganizationUser] Post Organization Invitation Complete',
  PostOrganizationInvitationError = '[OrganizationUser] Post Organization Invitation Error',
  PostGroupInvitation = '[OrganizationUser] Post Group Invitation',
  PostGroupInvitationComplete = '[OrganizationUser] Post Group Invitation Complete',
  PostGroupInvitationError = '[OrganizationUser] Post Group Invitation Error',
  DeletePendingOrganizationUser = '[OrganizationUser] Delete Pending Organization User',
  DeletePendingOrganizationUserComplete = '[OrganizationUser] Delete Pending Organization User Complete',
  DeletePendingOrganizationUserError = '[OrganizationUser] Delete Pending Organization User Error',
  DeletePendingOrganizationMember = '[OrganizationUser] Delete Pending Organization Member',
  DeletePendingOrganizationMemberComplete = '[OrganizationUser] Delete Pending Organization Member Complete',
  DeletePendingOrganizationMemberError = '[OrganizationUser] Delete Pending Organization Member Error'
}

export class GetOrganizationUsers implements Action {
  readonly type = OrganizationUserActionTypes.GetOrganizationUsers;

  constructor(public payload: GetOrganizationUsersRequest) {
  }
}

export class GetOrganizationUsersComplete implements Action {
  readonly type = OrganizationUserActionTypes.GetOrganizationUsersComplete;

  constructor(public payload: OrganizationUser[]) {
  }
}

export class GetOrganizationUsersError implements Action {
  readonly type = OrganizationUserActionTypes.GetOrganizationUsersError;

  constructor(public payload: ErrorPayload) {
  }
}

export class GetSelfOrganizationUser implements Action {
  readonly type = OrganizationUserActionTypes.GetSelfOrganizationUser;

  constructor(public payload: GetSelfOrganizationUserRequest) {
  }
}

export class GetSelfOrganizationUserComplete implements Action {
  readonly type = OrganizationUserActionTypes.GetSelfOrganizationUserComplete;

  constructor(public payload: SelfOrganizationUser) {
  }
}

export class GetSelfOrganizationUserError implements Action {
  readonly type = OrganizationUserActionTypes.GetSelfOrganizationUserError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostOrganizationInvitation implements Action {
  readonly type = OrganizationUserActionTypes.PostOrganizationInvitation;

  constructor(public payload: PostOrganizationInvitationRequest) {
  }
}

export class PostOrganizationInvitationComplete implements Action {
  readonly type = OrganizationUserActionTypes.PostOrganizationInvitationComplete;
}

export class PostOrganizationInvitationError implements Action {
  readonly type = OrganizationUserActionTypes.PostOrganizationInvitationError;

  constructor(public payload: ErrorPayload) {
  }
}

export class PostGroupInvitation implements Action {
  readonly type = OrganizationUserActionTypes.PostGroupInvitation;

  constructor(public payload: PostGroupInvitationRequest) {
  }
}

export class PostGroupInvitationComplete implements Action {
  readonly type = OrganizationUserActionTypes.PostGroupInvitationComplete;
}

export class PostGroupInvitationError implements Action {
  readonly type = OrganizationUserActionTypes.PostGroupInvitationError;

  constructor(public payload: ErrorPayload) {
  }
}

export class DeletePendingOrganizationUser implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationUser;

  constructor(public payload: DeletePendingOrganizationUserRequest) {
  }
}

export class DeletePendingOrganizationUserComplete implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationUserComplete;
}

export class DeletePendingOrganizationUserError implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationUserError;

  constructor(public payload: ErrorPayload) {
  }
}

export class DeletePendingOrganizationMember implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationMember;

  constructor(public payload: DeletePendingOrganizationMemberRequest) {
  }
}

export class DeletePendingOrganizationMemberComplete implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationMemberComplete;
}

export class DeletePendingOrganizationMemberError implements Action {
  readonly type = OrganizationUserActionTypes.DeletePendingOrganizationMemberError;

  constructor(public payload: ErrorPayload) {
  }
}

export type OrganizationUserActions =
  | GetOrganizationUsers
  | GetOrganizationUsersComplete
  | GetOrganizationUsersError
  | GetSelfOrganizationUser
  | GetSelfOrganizationUserComplete
  | GetSelfOrganizationUserError
  | PostOrganizationInvitation
  | PostOrganizationInvitationComplete
  | PostOrganizationInvitationError
  | PostGroupInvitation
  | PostGroupInvitationComplete
  | PostGroupInvitationError
  | DeletePendingOrganizationUser
  | DeletePendingOrganizationUserComplete
  | DeletePendingOrganizationUserError
  | DeletePendingOrganizationMember
  | DeletePendingOrganizationMemberComplete
  | DeletePendingOrganizationMemberError;
